import { yupResolver } from '@hookform/resolvers/yup';
import { useCallback, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { ObjectSchema } from 'yup';
import { FormFieldsContainer } from '../../../components/Form/FormComponents';
import { FormFactoryWithStandardLayout } from '../../../components/Form/FormFactory';
import { StickyFormButtons } from '../../../components/Form/StickyFormButtons';
import { IField } from '../../../data-models/field2.data-model';
import { useDynamicKpiConfigForm, useKpiConfigSchema } from '../../../schemas/KpiConfigForm.schema';
import { useKpiConfigActions } from './kpi-config-actions';
import { useResetKpiConfigFormState } from './kpi-config-form-state';

type KpiConfigFormProps = {
  defaultValues?: Partial<IField<unknown>> | null;
  onSubmit?: (data: IField<unknown>) => void;
};
export function KpiConfigForm({ defaultValues, onSubmit }: KpiConfigFormProps) {
  const schema = useKpiConfigSchema();

  const methods = useForm<Partial<IField<unknown>>>({
    resolver: yupResolver(schema as ObjectSchema<Partial<IField<unknown>>>),
    defaultValues: defaultValues ?? (schema.getDefault() as unknown as Partial<IField<unknown>>),
  });

  const createOrUpdateKpiConfig = useKpiConfigActions();
  const resetKpiConfigFormState = useResetKpiConfigFormState();

  const [loading, setLoading] = useState(false);
  const onSave = useCallback(
    async (data: Partial<IField<unknown>>) => {
      setLoading(true);
      const res = await createOrUpdateKpiConfig(data);
      setLoading(false);
      if (res) {
        resetKpiConfigFormState();
        onSubmit?.(res);
      }
    },
    [createOrUpdateKpiConfig, resetKpiConfigFormState, onSubmit]
  );
  return (
    <div>
      <FormProvider {...methods}>
        <FormFieldsContainer>
          <KpiConfigFormFields />
        </FormFieldsContainer>
        <StickyFormButtons
          onSubmit={methods.handleSubmit(onSave)}
          onCancel={resetKpiConfigFormState}
          loading={loading}
        />
      </FormProvider>
    </div>
  );
}

function KpiConfigFormFields() {
  const form = useDynamicKpiConfigForm();
  return <FormFactoryWithStandardLayout form={form} />;
}
